<template>
  <b-card id="container-entities">
    <div class="row">
      <h3 class="col-12">Entidades</h3>
      <div class="col-12">
        <WareHousesFilters
          :value="filters"
          :onChange="onChangeFilters"
          :clear="clearFilters"
        />
      </div>
      <div class="col-12 text-left mb-3">
        <b-button
          pill
          variant="primary"
          size="sm"
          v-has-permission="'ED202'"
          @click="addEntity()"
          data-cy="add"
        >
          <b-icon icon="plus-circle-fill"></b-icon>
          Agregar Entidad
        </b-button>
      </div>
    </div>
    <div class="row">
      <b-table
        hover
        :fields="fieldEntities"
        :items="filteredEntities"
        :tbody-tr-attr="{'data-cy': 'file'}"
      >
        <template #cell(actions)="row">
          <div class="row justify-content-end">
            <div v-tooltip="'Editar Entidad'">
              <b-icon
                v-has-permission="'ED203'"
                class="h3 m-2"
                icon="pencil"
                v-on:click.stop.prevent="editEntity(row.item)"
                data-cy="edit"
              />
            </div>
            <div v-tooltip="'Eliminar Entidad'">
              <b-icon
                v-has-permission="'ED204'"
                class="h3 m-2"
                icon="trash"
                v-on:click.stop.prevent="showAlertDeleteEntity(row.item)"
                data-cy="remove"
              />
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="mt-5">
          Mostrando
          <select v-model="rowspp" @change="fetchEntities()">
            <option value="10" selected="selected">10</option>
            <option value="15">15</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select> registros por página.
        </div>
      </div>
      <div class="col-9">
        <EntitiesPagination
          :show="pagination.pages"
          v-model="page"
        />
      </div>
    </div>
    <b-modal
      id="new-entity"
      ref="newEntity"
      :title="newitem.isEdit?'Editar Entidad':'Nueva Entidad'"
      hide-footer
      no-close-on-backdrop
    >
      <div class="row mb-5">
        <form data-vv-scope="newitem" class="col-12">
          <div class="col-md-12 mt-3">
            <label>Código</label>
            <b-form-input
              placeholder="Ingresa Código"
              size="md"
              v-model="newitem.code"
              name="code"
              :state="errors.has('newitem.code') ? false : null"
              v-validate="'required|min:3'"
            />
            <b-form-invalid-feedback>
              {{ errors.first('newitem.code') }}
            </b-form-invalid-feedback>
          </div>
          <div class="col-md-12 mt-3">
            <label>Nombre</label>
            <b-form-input
              placeholder="Ingresa Nombre"
              size="md"
              v-model="newitem.name"
              name="name"
              :state="errors.has('newitem.name') ? false : null"
              v-validate="'required|min:3'"
            />
            <b-form-invalid-feedback>
              {{ errors.first('newitem.name') }}
            </b-form-invalid-feedback>
          </div>
          <div class="col-md-12 mt-3">
            <b-button
              class="btn btn-primary pull-right ml-3 mt-5"
              size="md"
              @click="saveEntity()"
              data-cy="next-button"
            >
              <feather-icon icon="SaveIcon"/>
              Guardar
            </b-button>
          </div>
        </form>
      </div>
    </b-modal>
  </b-card>
</template>
<script>
import { uuid } from 'vue-uuid';
import { mapActions, mapGetters } from 'vuex';

import EntitiesPagination from '@/febos/aduanas/management/entities/views/components/EntitiesPagination';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import WareHousesFilters from '@/febos/aduanas/management/warehouses/views/components/WareHousesFilters';

export default {
  components: {
    WareHousesFilters,
    EntitiesPagination,
  },
  data() {
    return {
      list: [],
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10),
      page: Number.parseInt(this.$route.query.page || 1, 10),
      newitem: { parameters: [] },
      filters: '',
    };
  },
  watch: {
    async page(page) {
      updateSearchParams({ page });
      await this.fetchEntities();
    },
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#container-entities > .con-vs-loading');
        return;
      }
      this.$vs.loading({
        container: '#container-entities',
        scale: 0.6
      });
    },
  },
  computed: {
    ...mapGetters('entities', [
      'listEntities',
      'loading',
      'pagination',
      'fieldEntities'
    ]),
    filteredEntities() {
      return this.listEntities;
    }
  },
  methods: {
    ...mapActions('entities', [
      'saveNewEntities',
      'loadListEntities'
    ]),
    showAlertDeleteEntity(item) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: '¿Estás seguro que deseas eliminar la entidad '.concat(item.descripcion).concat('?'),
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.saveDeleteEntity(item)
      });
    },
    async saveDeleteEntity(item) {
      const param = {
        holding: 'si',
        id: item.opcionId
      };
      const body = {
        grupoId: 'io.aduanas.entidades',
        parametroId: item.parametroId,
        deshabilitado: 1,
      };
      await this.saveNewEntities({ param, body });
      this.$vs.notify({
        title: 'Genial!',
        text: 'Se ha removido exitosamente la entidad',
        color: 'success',
        time: 4000,
        position: 'top-center'
      });
      this.$refs.newEntity.hide();
      await this.fetchEntities();
    },
    async fetchEntities() {
      const body = {
        grupoOpcion: 'io.aduanas.entidades',
        filtros: this.getFilters(),
        pagina: this.page,
        itemsPorPagina: this.rowspp,
      };
      await this.loadListEntities(body);
    },
    editEntity(item) {
      this.newitem = {
        opcionId: item.opcionId,
        parametroId: item.parametroId,
        name: item.descripcion,
        code: item.valor,
        isEdit: true
      };
      this.$refs.newEntity.show();
    },
    async saveEntity() {
      const isValid = await this.validateForm('newitem');
      if (!isValid) {
        return;
      }
      let param = {
        holding: 'si'
      };
      let body = {
        grupoId: 'io.aduanas.entidades',
        descripcion: this.newitem.name,
        valor: this.newitem.code
      };
      if (this.newitem.isEdit) {
        param = {
          ...param,
          id: this.newitem.opcionId
        };
        body = {
          ...body,
          parametroId: this.newitem.parametroId
        };
      } else {
        body = {
          ...body,
          parametroId: uuid.v4(),
          orden: this.pagination.items + 1,
          deshabilitado: 0,
        };
      }
      await this.saveNewEntities({ param, body });
      this.$refs.newEntity.hide();
      this.$vs.notify({
        title: 'Genial!',
        text: 'Se ha guardado exitosamente la entidad',
        color: 'success',
        time: 4000,
        position: 'top-center'
      });
      await this.fetchEntities();
    },
    addEntity() {
      this.newitem = {
        code: '',
        name: '',
        isEdit: false
      };
      this.$refs.newEntity.show();
    },
    clearFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      updateSearchParams({ page: 0 });
      this.$router.go();
    },
    getFilters() {
      // Esta condición es para ver referencias en base a febosId
      if (this.$route.query?.filters) {
        if (this.$route.query.filters.includes('opcionId')) {
          return this.$route.query.filters;
        }
      }
      return mergeFilters(this.filters, this.$route.query.filters);
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force fetch (if we change the page from 1 to 1 the watcher not run)
          await this.fetchEntities();
        }
      }
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
  },
  mounted() {
    this.fetchEntities();
  },
};
</script>
<style>
  .button-add-entities {
    position: absolute;
    right: 1px;
  }
</style>
